/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { combineReducers } from 'redux';
import contentStatus from 'redux/reducers/content_status';
import settings from 'redux/reducers/settings';
import queueStatus from 'redux/reducers/queue_status';
import contentData from 'redux/reducers/content_data';
import pauseStatus from 'redux/reducers/pause_status';
import embedStatus from 'redux/reducers/embed_status';
import sessionStatus from 'redux/reducers/session_status';
import screenStatus from 'redux/reducers/screen_status';
import rewards from 'redux/reducers/rewards'



/* ========== ~~~~~~~~~~ ROOT REDUCER ~~~~~~~~~~ ========== */
// COMBINE REDUCERS
// used to comhine all various reducers together into an easily accesible object
// utilized in store.js
const rootReducer = combineReducers({
    contentStatus,
    settings,
    queueStatus,
    contentData,
    pauseStatus,
    embedStatus,
    sessionStatus,
    screenStatus,
    rewards
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default rootReducer;
